import styled from "styled-components";

export const TableGrid = styled.table`
  position: relative;
  border-collapse: collapse;
  width: 100%;
  margin-top: 28px;
  margin-bottom: 28px;
`;

export const TableDataPadding = styled.td`
  padding-bottom: 14px;
  padding-top: 14px;
`;

export const TableData = styled(TableDataPadding)`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500 !important;
  font-size: 16px;
  line-height: 24px;
  color: #05162a;
`;

export const TableDataNormal = styled(TableData)`
  font-weight: 400 !important;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid rgb(217 224 235 / 80%);
`;

export const TableHead = styled.th`
  text-align: left;
  font-family: "Poppins";
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -2%;
  color: rgba(138, 145, 156, 0.8);
  padding-bottom: 16px;
  width: 30%;
`;

export const EditButton = styled.button`
  font-family: "Poppins";
  font-size: 16px;
  line-height: 24px;
  color: #4d9fc4;
  outline: none;
  border: none;
  background: transparent;
  float: right;
  margin-right: 8px;
  cursor: pointer;
  font-weight: 500;
`;

export const EllipsePara = styled.p`
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 270px;
  overflow: hidden;
`;
